import o from "react";
import s from "./userTag.module.scss.js";
function l({
  tag: t,
  textColor: e = "#FFF",
  backgroundColor: r = "#000",
  selected: a = !0
}) {
  return /* @__PURE__ */ o.createElement(
    "div",
    {
      "data-testid": "user-tag",
      className: s.tag,
      style: {
        color: e,
        backgroundColor: r,
        opacity: a ? "1" : "0.6"
      }
    },
    t
  );
}
export {
  l as UserTag
};
//# sourceMappingURL=UserTag.js.map
